import { Immutable } from "immer";
import React from "react";

import type { VariantHeroBlock as Value } from "@reactivated";

import { HeroPicture } from "../HeroPicture";

type Props = Immutable<{
    value: Value;
}>;

export const VariantHeroBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    return (
        <HeroPicture
            imageUrl={v.image?.url ?? null}
            imageAlt={v.image?.title ?? ""}
            mobileImageUrl={v.mobile_image?.url ?? null}
        />
    );
};
